import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'react-bootstrap'
import styles from './../blocks.module.sass'

class FeedbackWidget extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return <div className='w-100' dangerouslySetInnerHTML={{__html: this.props.html}} />;
  }
}

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    this.setState({
      loading: false
    })
  }

  render() {
    const { ajax_data } = this.props,
    { loading } = this.state

    if(!('feedback_ng' in ajax_data) || loading) return (
      <></>
    )

    return (
      <div className={styles.feedbackng}>
        <Container>
          <div className='d-flex align-items-end justify-content-between'>
            <div className={styles.feedbackng_title}>
              УЗНАЙТЕ, ЧТО КЛИЕНТЫ<br />
              ГОВОРЯТ О НАС
            </div>
            <a href="https://yandex.ru/maps/org/bruno_altro/160467838800/?ll=37.617222%2C55.761457&z=16" 
               target="_blank" 
               rel="noopener noreferrer"
               className={styles.feedbackng_more}>
              Смотреть все →
            </a>
          </div>
          
          {ajax_data.feedback_ng_widget && 
            <div className='mt-4 d-flex justify-content-center'>
              <FeedbackWidget html={ajax_data.feedback_ng_widget} />
            </div>
          }
        </Container>
      </div>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object
}